import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useIsMobile } from "../../../hooks";
import { Typo } from "../../../Typo";
import {
  MobileSortBottomSheet,
  SortOption,
} from "../../Common/controls/MobileSortBottomSheet";
import { ReturnedTranslatedContentClientsPageHook } from "../../types";
import { useClientAccountReportContext } from "../providers/AccountReportProvider";

type ClientAccountReportSortProps = {
  isMobileBottomSheetEnable: boolean;
  translations: ReturnedTranslatedContentClientsPageHook;
};

export const ClientAccountReportSort = ({
  isMobileBottomSheetEnable,
  translations,
}: ClientAccountReportSortProps) => {
  const {
    state: { sortBy, sortOrder },
    actions: { setSort },
    runResource,
  } = useClientAccountReportContext();
  const isMobile = useIsMobile();
  const { t } = useTranslation();

  const { accountColumnLabels } =
    translations.translatedContent.accountReportTab;

  const sortOptions: SortOption[] = useMemo(
    () => [
      {
        id: "firstTradedDate",
        label: accountColumnLabels.firstTradedDate,
      },
      {
        id: "lastTradedDate",
        label: accountColumnLabels.lastTradedDate,
      },
    ],
    [accountColumnLabels.firstTradedDate, accountColumnLabels.lastTradedDate],
  );

  const newestFirstLabel = t("clientsPage_sort_Bottomsheet_newestFirst");
  const oldestFirstLabel = t("clientsPage_sort_Bottomsheet_oldestFirst");

  if (!isMobileBottomSheetEnable || !isMobile) {
    return null;
  }

  return (
    <div className="sticky top-[136px] z-10 -mb-4 mt-4 bg-surface-primary pb-2">
      <div className="flex h-10 items-center gap-6">
        <div className="min-w-0 flex-1">
          <MobileSortBottomSheet
            sortOptions={sortOptions}
            selectedSortBy={sortBy ?? "lastTradedDate"}
            selectedSortOrder={sortOrder ?? "desc"}
            onApply={(newSortBy, newSortOrder) =>
              setSort(newSortBy, newSortOrder)
            }
            getOrderLabels={() => ({
              descLabel: newestFirstLabel,
              ascLabel: oldestFirstLabel,
            })}
          />
        </div>
        <div className="flex shrink-0 flex-row items-center">
          <button
            onClick={() => runResource("csv")}
            className="flex h-10 cursor-pointer items-center justify-center rounded-lg bg-surface-tonal-default px-3 py-2"
          >
            <Typo type="labelSM">
              {translations.translatedContent.exportCSVText}
            </Typo>
          </button>
        </div>
      </div>
    </div>
  );
};
